import script from "./infoRow.vue?vue&type=script&setup=true&lang=js"
export * from "./infoRow.vue?vue&type=script&setup=true&lang=js"

import "./infoRow.vue?vue&type=style&index=0&id=2a40319b&scoped=true&lang=css"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a40319b"]])

export default __exports__